import { createModel } from '@/store/tools';

const model = {
    namespace: 'messageMove',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getlistMessageInfo': T('getlistMessageInfo'), // 获取消息列表
            'getMessageInfo': T('getMessageInfo'), // 获取消息详情
            'getSystemTypeEnum': T('getSystemTypeEnum'), // 系统类型下拉
            'getMessagePushModeEnum': T('getMessagePushModeEnum'), // 推送方式下拉
            'getMessageStateEnum': T('getMessageStateEnum'), // 消息状态下拉
            'getItemAll': T('getItemAll'), // 获取自定义链接跳转列表类型-全部列表
            'getlistStrategyInfoToMessage': T('getlistStrategyInfoToMessage'), // 获取攻略列表(新建消息推送 跳转链接选择用)
        },
        actions: {
             'getlistMessageInfo': A('getlistMessageInfo'), // 获取消息列表
             'getMessageInfo': A('getMessageInfo'), // 获取消息详情
             'getCleanDetail': C('getMessageInfo'), // 管理清除详情数据
             'getSystemTypeEnum': A('getSystemTypeEnum'), // 系统类型下拉
             'getMessagePushModeEnum': A('getMessagePushModeEnum'), // 推送方式下拉
             'getMessageStateEnum': A('getMessageStateEnum'), // 消息状态下拉
             'getItemAll': A('getItemAll'), // 获取自定义链接跳转列表类型-全部列表
             'getlistStrategyInfoToMessage': A('getlistStrategyInfoToMessage'), //获取攻略列表(新建消息推送 跳转链接选择用)
        },
        sagas: {
            'getlistMessageInfo': S('getlistMessageInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.listMessageInfo'),
            'getMessageInfo': S('getMessageInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.getMessageInfo'),
            'getSystemTypeEnum': S('getSystemTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getMessagePushModeEnum': S('getMessagePushModeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getMessageStateEnum': S('getMessageStateEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getItemAll': S('getItemAll', '/?cmd=com.xqxc.api.pig.mis.biz.platform.MessageInfoMisService.getItemAll'),
            'getlistStrategyInfoToMessage': S('getlistStrategyInfoToMessage', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.listStrategyInfoToMessage'),
        },
        reducers: {
            'listMessageInfo': R('getlistMessageInfo', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'MessageInfo': R('getMessageInfo', {}),
            'SystemTypeEnum': R('getSystemTypeEnum', []),
            'MessagePushModeEnum': R('getMessagePushModeEnum', []),
            'MessageStateEnum': R('getMessageStateEnum', []),
            'ItemAll': R('getItemAll', []),
            'listStrategyInfoToMessage': R('getlistStrategyInfoToMessage', []),
        }
    })
};
export default createModel(model);